const sortTagsByName = (a, b) => {
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return -1;
};

export const getVisibleClientTags = (selectedTags, searchText) => {
  if (searchText) {
    const lowerSearchText = searchText.toLowerCase();

    return selectedTags.filter(tag => tag.name.toLowerCase().includes(lowerSearchText));
  }

  const selected = selectedTags.filter(tag => tag.client_id !== null);
  const unselected = selectedTags.filter(tag => tag.client_id === null).sort(sortTagsByName);

  return selected.concat(unselected);
};
